module.exports = __webpack_public_path__ + "img/logo-pure-blue.3175beed.svg";